<template>
    <div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>文件名称</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-input @blur="changeDesc()" v-model="servcWorkImg.desc" class="width-2x" type="text" auto-complete="off"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>设置标签</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x bottom-line" :disabled="true" v-model="servcWorkImg.tagName"></el-input>
                    <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="setTag($event)"></i>
                    <i class="input-deletable" v-if="servcWorkImg.tagName != null" @click="removeCancel">×</i>
                </div>
            </div>
        </div>
        <swb-dt-popover ref="attPopoverRef" classes="popper-tabs">
            <swb-att-tag-list-for-select :attAspect="attAspect" :selectName="tagName" ref="swb_att_tag_list_for_select" @notity-attTag-comfirm="doAttTagConfirm" @notity-attTag-cancel="doAttTagCancel"></swb-att-tag-list-for-select>
        </swb-dt-popover>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes, getComnMerchantAttTag } from '../../app.vues'
    import servcDelivApi from '../../api/servcDeliv';
    import SwbAttTagListForSelect from '../attTag/AttTagListForSelect'
    Vue.regist(SwbAttTagListForSelect);
    let bizTagObj = null;
    export default {
        name: 'swb-servc-voucher-img-update',
        desc: '工單信息上產',
        props: ['id'],
        data: function () {

            return {
                // 资产图片
                servcWorkImg: {},
                attAspect: getEnumInfoWith('retailerAttAspect', 'name', 'WorkVoucher').value,
            }
        },
        created: function () {
            bizTagObj = getComnMerchantAttTag();
            this.getServcWorkImgFile();
        },
        methods: {
            getServcWorkImgFile: function () {
                let self = this;
                let postData = {
                    id: self.id
                }
                servcDelivApi.getServcWorkImgFileById(postData, function (result) {
                    if(result.type == "info") {
                        let servcWorkImg = result.data;
                        let desc = servcWorkImg.desc;
                        let index = desc.lastIndexOf("_")
                        servcWorkImg.desc = desc.substring(0, index);
                        servcWorkImg.ts = desc.substring(index + 1);
                        self.servcWorkImg = servcWorkImg;
                    } else {
                        MsgBox.warning(result.message);
                        return;
                    }
                })
            },
            getFileName(fileName, ts){
                if(fileName != null) {
                    return fileName + "_" + ts;
                } else {
                    return ts;
                }
            },
            changeDesc: function () {
                if(this.servcWorkImg.desc.length > 50) {
                    MsgBox.warning("文件名称不可多于50个字");
                    return;
                }
            },
            setTag: function (event) {
                this.showPopoverRef(event);
                let servcWorkImg = this.servcWorkImg;
                this.tagName = servcWorkImg.tagName;
            },
            showPopoverRef: function (event) {
                let curBtn = event.currentTarget;
                //
                let popoverRef = this.$refs.attPopoverRef;
                popoverRef.bindToReferer(
                    curBtn, 'click', {
                        showNow: true,
                        placement: 'bottom-start'
                    }
                )
            },
            doAttTagConfirm: function (data) {
                let self = this;
                let popoverRef = self.$refs.attPopoverRef;
                console.log(data);
                popoverRef.doClear();
                let servcWorkImg = self.servcWorkImg;
                servcWorkImg.tagName = data;

            },
            doAttTagCancel: function () {
                let popoverRef = this.$refs.attPopoverRef;
                popoverRef.doHide();
            },
            removeCancel: function () {
                let servcWorkImg = this.servcWorkImg;
                servcWorkImg.tagName = null;
                servcWorkImg.tagFlag = false;
            },
            getDlgResult: function () {
                let result = {};
                let servcWorkImg = this.servcWorkImg;
                if(servcWorkImg.desc.length > 50){
                    result.type = "warn";
                    result.message = "文件名称不可多于50个字";
                    return result;

                }
                let desc = this.getFileName(servcWorkImg.desc, servcWorkImg.ts);
                let tagName = servcWorkImg.tagName;
                let postData = {
                    desc:desc,
                    tagName:tagName,
                    tagFlag:servcWorkImg.tagFlag
                };
                result.data = postData;
                result.type = "info";
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkImgFileUpdate.vue